import React, { useEffect, useRef } from 'react';
import { Undo2, Trash2 } from 'lucide-react';
interface MergeEditorProps {
  htmlContent: string;
  onChange: (html: string) => void;
  onClear: () => void;
  onUndo: () => void;
  wordCount: number;
}
export const MergeEditor: React.FC<MergeEditorProps> = ({
  htmlContent,
  onChange,
  onClear,
  onUndo,
  wordCount
}) => {
  const editorRef = useRef<HTMLDivElement>(null);
  // Sync external changes to contentEditable
  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== htmlContent) {
      editorRef.current.innerHTML = htmlContent;
    }
  }, [htmlContent]);
  const handleInput = () => {
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };
  return <div className="flex flex-col h-full min-h-0 bg-white border-t border-slate-200" data-id="element-163">
      <div className="flex items-center justify-between px-4 py-2 border-b border-slate-100 bg-slate-50/80 shrink-0" data-id="element-164">
        <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-165">
          Merged Output
        </div>
        <div className="flex items-center gap-3" data-id="element-166">
          <span className="text-xs text-slate-400" data-id="element-167">{wordCount} words</span>
          <div className="w-px h-4 bg-slate-200" data-id="element-168"></div>
          <button onClick={onUndo} className="p-1.5 text-slate-400 hover:text-slate-700 hover:bg-slate-100 rounded transition-colors" title="Undo last selection" data-id="element-169">
            
            <Undo2 className="w-4 h-4" data-id="element-170" />
          </button>
          <button onClick={onClear} className="p-1.5 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors" title="Clear all" data-id="element-171">
            
            <Trash2 className="w-4 h-4" data-id="element-172" />
          </button>
        </div>
      </div>

      <div className="flex-1 min-h-0 overflow-y-auto" data-id="element-173">
        <div ref={editorRef} contentEditable onInput={handleInput} data-placeholder="Click sentences in the drafts above to build your translation, or type directly here..." className="content-editable-container w-full min-h-full p-6 outline-none font-legal text-[17px] leading-[1.8] text-slate-900" data-id="element-174" />
        
      </div>
    </div>;
};